import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DynamicHelpListComponent } from '../doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { Subject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
@Component({
  selector: 'app-doctor-review',
  templateUrl: './doctor-review.component.html',
  styleUrls: ['./doctor-review.component.scss'],
  providers  : [VoiceRecognitionService]
})
export class DoctorReviewComponent implements OnInit {
  destroyreview$: Subject<boolean> = new Subject<boolean>();
  showspinner: boolean = false;
  private examdetailArray: any = [];
  private searchValue02: any;
  // diagnosisComments:string ='';
  private examid: any;
  private appointmentid: number = 0;
  private nextreview: number = 0;
  private slot: string = '';
  private drdate: any;
  isheader:boolean=false;

  private nextreviewNote: string = '';
  private appoitmenttypearray: any = [];
  private rdate:any;
  constructor(private service : VoiceRecognitionService,private emrservice: EMRService, private dialog: MatDialog, private datePipe: DatePipe, 
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DoctorReviewComponent>,
    private opdvisitService: OpdVisitService, private dashboardService: DashboardService,private authservice:AuthService, private voice: VoiceRecognitionService,) { 
    this.service.init();

  }

  /** AI Scribe: apply the spoken follow-up plan to the review form, then clear. */
  consumeAiReview(): void {
    const p = this.emrservice.aiWorkupPending;
    if (!p || !p.review) { return; }
    const r = p.review;
    const d: any = this.opdvisitService.patientDrdetaill && this.opdvisitService.patientDrdetaill[0];
    if (!d || d.aiReviewFilled) { return; }   // idempotent; re-applies if the form object is reloaded
    if (r.nextReview && !isNaN(+r.nextReview)) { d.nextReview = +r.nextReview; }
    if (r.nextReviewUnit) { d.nextReviewUnit = r.nextReviewUnit; }
    if (r.nextReviewNote) { d.nextReviewNote = r.nextReviewNote; }
    d.aiReviewFilled = true;
    this.emrservice.enabledisablebtnRev = false;
  }

  /** Per-tab AI fill — applies only the review slice. */
  aiFillReview(s: any): void {
    const d: any = this.opdvisitService.patientDrdetaill && this.opdvisitService.patientDrdetaill[0];
    if (d) { d.aiReviewFilled = false; }
    this.emrservice.applyAiWorkup({ review: (s && s.review) || {} });
  }

  ngOnInit(): void {
    if(this.data){
      this.isheader = this.data.isheader;
     }else{
       this.isheader = false;
     }
    this.emrservice.enabledisablebtnRev =true;

    // AI Scribe — pre-fill the follow-up plan from a voice consultation
    this.emrservice.aiWorkup$.pipe(takeUntil(this.destroyreview$)).subscribe(() => this.consumeAiReview());
    interval(1500).pipe(takeUntil(this.destroyreview$)).subscribe(() => this.consumeAiReview());

    this.emrservice.share.pipe(takeUntil(this.destroyreview$)).subscribe((x: any) => {

      if (x == 2) {
      //  this.getReviewData(this.opdvisitService.patientdetails.pkRegId);
        this.examid = this.emrservice.examid;
        if(this.opdvisitService.patientDrdetaill[0].nextReviewUnit ==null){
          this.opdvisitService.patientDrdetaill[0].nextReviewUnit='D';
        }
        if(this.opdvisitService.patientDrdetaill[0].nextReview ==null){
          this.opdvisitService.patientDrdetaill[0].nextReview=0;
        }
        if(this.opdvisitService.patientDrdetaill[0].nextReviewDate !=null && this.opdvisitService.patientDrdetaill[0].nextReviewDate !=undefined){
          if (Date.parse(this.datePipe.transform(this.opdvisitService.patientDrdetaill[0].nextReviewDate, "yyyy-MM-dd").toString()) >= Date.parse(this.datePipe.transform("1930-12-01").toString())){
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(this.opdvisitService.patientDrdetaill[0].nextReviewDate, "yyyy-MM-dd");
          }else{
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
          }
         
        }else{
          this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
        }

      }
     
      if(x==22){
        this.examid = this.emrservice.examid;
        if(this.opdvisitService.patientDrdetaill[0].nextReviewUnit ==null){
          this.opdvisitService.patientDrdetaill[0].nextReviewUnit='D';
        }
        if(this.opdvisitService.patientDrdetaill[0].nextReview ==null){
          this.opdvisitService.patientDrdetaill[0].nextReview=0;
        }
        if(this.opdvisitService.patientDrdetaill[0].nextReviewDate !=null && this.opdvisitService.patientDrdetaill[0].nextReviewDate !=undefined){
          if (Date.parse(this.datePipe.transform(this.opdvisitService.patientDrdetaill[0].nextReviewDate, "yyyy-MM-dd").toString()) >= Date.parse(this.datePipe.transform("1930-12-01").toString())){
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(this.opdvisitService.patientDrdetaill[0].nextReviewDate, "yyyy-MM-dd");
          }else{
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
          }
         
        }else{
          this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
        }
       
      }
    });
    
    this.GetAppoitment();

    this.rdate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.emrservice.componentClicked$.subscribe(() => {
      if(!this.emrservice.enabledisablebtnRev){
        setTimeout(()=>{ 
          if(this.emrservice.examid>0){
            this.examid =this.emrservice.examid;
            this.saveDrReview(1);
          }
          }, 100);
       
      }
    });
  }
  getReviewData(regid) {
   
    this.emrservice.GetFindingGResultByregid(regid,this.opdvisitService.visitid,this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroyreview$)).subscribe((item: any) => {
      this.emrservice.patientEMRdetail = [];
      this.examdetailArray = [];
      this.emrservice.patientEMRdetail = item;
      this.examdetailArray = this.emrservice.patientEMRdetail.filter(item => item.pK_ExamId == this.examid);
      if (this.examdetailArray.length > 0) {
        this.appointmentid = this.examdetailArray[0].fK_OptoId;
        this.nextreview = this.examdetailArray[0].nextReview;
        if(this.examdetailArray[0].nextReviewUnit !=null){
          this.slot = this.examdetailArray[0].nextReviewUnit;
        }else{
          this.slot = 'D';
        }
        
        if(this.examdetailArray[0].nextReviewDate !=null && this.examdetailArray[0].nextReviewDate !=undefined){
          if (Date.parse(this.datePipe.transform(this.examdetailArray[0].nextReviewDate, "yyyy-MM-dd").toString()) >= Date.parse(this.datePipe.transform("1930-12-01").toString())){
            this.drdate = this.datePipe.transform(this.examdetailArray[0].nextReviewDate, "yyyy-MM-dd");
          }else{
            this.drdate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
          }
         
        }else{
          this.drdate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
        }
        this.nextreviewNote = this.examdetailArray[0].nextReviewNote;
      } else {
        this.appointmentid = 0;
        this.opdvisitService.patientDrdetaill[0].nextReview = 0;
        this.opdvisitService.patientDrdetaill[0].nextReviewUnit = 'D';
        this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
        this.opdvisitService.patientDrdetaill[0].nextReviewNote = '';
      }
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }


  Cleardata() {
    this.emrservice.enabledisablebtnRev =true;
    this.appointmentid = 0;
    this.opdvisitService.patientDrdetaill[0].nextReview = 0;
    this.opdvisitService.patientDrdetaill[0].nextReviewUnit = 'D';
    this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.opdvisitService.patientDrdetaill[0].nextReviewNote = '';
  }
  GetAppoitment() {
    this.emrservice.getappoitmentType().pipe(takeUntil(this.destroyreview$)).subscribe((x: any) => {
      this.appoitmenttypearray = x;
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  // openAppointment() {
  //   const dialogRefApp = this.dialog.open(DoctorAppointmentComponent, {
  //     panelClass: 'full-width-dialog',
  //     maxWidth: '90%',
  //     width: '90%',
  //     height: '90%'
  //   });
  //   dialogRefApp.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed Appointment');
  //   });
  // }

  onReviewGrid(event: any, type) {   
    this.emrservice.enabledisablebtnRev =false;
    switch (type) {
      case (1): {
        this.opdvisitService.patientDrdetaill[0].nextReview = event;
        if (this.opdvisitService.patientDrdetaill[0].nextReview > 0) {
          if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'D') {
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = null;
            var n4 = this.opdvisitService.patientDrdetaill[0].nextReview;
            var today4 = new Date();
            var requiredDate4 = today4.setDate(today4.getDate() + Number(n4));
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(requiredDate4, 'yyyy-MM-dd');
          } else if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'W') {
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = null;
            var n5 = this.opdvisitService.patientDrdetaill[0].nextReview * 7;
            var today5 = new Date();
            var requiredDate5 = today5.setDate(today5.getDate() + Number(n5));
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(requiredDate5, 'yyyy-MM-dd');
          } else if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'M') {
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = null;
            var n6 = this.opdvisitService.patientDrdetaill[0].nextReview;
            var today6 = new Date();
            var requiredDate6 = new Date(today6.getFullYear(), today6.getMonth() + Number(n6), today6.getDate());
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(requiredDate6, 'yyyy-MM-dd');
          } else if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'Y') {
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = null;
            var n7 = this.opdvisitService.patientDrdetaill[0].nextReview;
            var today7 = new Date();
            var requiredDate7 = new Date(today7.getFullYear() + Number(n7), today7.getMonth(), today7.getDate());
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(requiredDate7, 'yyyy-MM-dd');
          }
        } else {
          this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        }
        break;
      }
      case (2): {
        this.opdvisitService.patientDrdetaill[0].nextReviewUnit = event;
        if (this.opdvisitService.patientDrdetaill[0].nextReview > 0) {
          if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'D') {
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = null;
            var n = this.opdvisitService.patientDrdetaill[0].nextReview;
            var today = new Date();
            var requiredDate = today.setDate(today.getDate() + Number(n));
            this.opdvisitService.patientDrdetaill[0].nextReviewDate= this.datePipe.transform(requiredDate, 'yyyy-MM-dd');
          } else if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'W') {
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = null;
            var n1 = this.opdvisitService.patientDrdetaill[0].nextReview * 7;
            var today1 = new Date();
            var requiredDate1 = today1.setDate(today1.getDate() + Number(n1));
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(requiredDate1, 'yyyy-MM-dd');
          } else if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'M') {
            this.opdvisitService.patientDrdetaill[0].nextReviewDate= null;
            var n2 = this.opdvisitService.patientDrdetaill[0].nextReview;
            var today2 = new Date();
            var requiredDate2 = new Date(today2.getFullYear(), today2.getMonth() + Number(n2), today2.getDate());
            this.opdvisitService.patientDrdetaill[0].nextReviewDate= this.datePipe.transform(requiredDate2, 'yyyy-MM-dd');
          } else if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'Y') {
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = null;
            var n3 = this.opdvisitService.patientDrdetaill[0].nextReview;
            var today3 = new Date();
            var requiredDate3 = new Date(today3.getFullYear() + Number(n3), today3.getMonth(), today3.getDate());
            this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(requiredDate3, 'yyyy-MM-dd');
          }
        } else {
          this.opdvisitService.patientDrdetaill[0].nextReviewDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        }
        break;
      }
      case(3):{    
          this.opdvisitService.patientDrdetaill[0].nextReview = this.calculateDiff(this.opdvisitService.patientDrdetaill[0].nextReviewDate);
     
        if (this.opdvisitService.patientDrdetaill[0].nextReview > 0) {
if(this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'D'){
  this.opdvisitService.patientDrdetaill[0].nextReview = this.calculateDiff(this.opdvisitService.patientDrdetaill[0].nextReviewDate);
}else if(this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'W'){
if( this.opdvisitService.patientDrdetaill[0].nextReview >= 7){
  var weekdays = Math.floor(this.opdvisitService.patientDrdetaill[0].nextReview/7);
  this.opdvisitService.patientDrdetaill[0].nextReview =  weekdays;
}
}else if(this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'M'){
  this.opdvisitService.patientDrdetaill[0].nextReview = this.monthDiff( new Date(),new Date(this.opdvisitService.patientDrdetaill[0].nextReviewDate));

}else if(this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'Y'){
  this.opdvisitService.patientDrdetaill[0].nextReview =  new Date(this.opdvisitService.patientDrdetaill[0].nextReviewDate).getFullYear() - new Date().getFullYear(); 
}
        }
        break;
      }
      case (4): {
        this.appointmentid = event;
        break;
      }
      case (5): {
        this.opdvisitService.patientDrdetaill[0].nextReviewNote = event;
        break;
      }
    }
  }
  saveDrReview(type:any) {
    if(Date.parse(this.datePipe.transform(new Date(this.authservice.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authservice.Loggeduser.usertypeid ==9) {
      if(this.authservice.Loggeduser.usertypeid ==6){
        if(this.authservice.Loggeduser.userid != this.opdvisitService.DoctorIdEmr){   
           this.showspinner = false;  
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
    if(this.emrservice.reviewPermission.isAddPermission ==true){
    if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
    //  if(this.opdvisitService.patientDrdetaill[0].nextReview >0){
      if (this.examid == null || this.examid == undefined) {
        this.examid = 0;
      }
      if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'D' && this.opdvisitService.patientDrdetaill[0].nextReview >1826) {
       return this.dashboardService.openSnackBar("You cannot enter review after more than 1826 days", "OK");
      }
      if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'M' && this.opdvisitService.patientDrdetaill[0].nextReview >60) {
        return this.dashboardService.openSnackBar("You cannot enter review after more than 60 months", "OK");
       }
       if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'W' && this.opdvisitService.patientDrdetaill[0].nextReview >261) {
        return this.dashboardService.openSnackBar("You cannot enter review after more than 261 weeks", "OK");
       }
       if (this.opdvisitService.patientDrdetaill[0].nextReviewUnit == 'Y' && this.opdvisitService.patientDrdetaill[0].nextReview >5) {
        return this.dashboardService.openSnackBar("You cannot enter review after more than 5 years", "OK");
       }
      if (this.opdvisitService.patientdetails.pkRegId) {
          
        if(this.drdate !=null && this.drdate!= ''){
          if (Date.parse(this.datePipe.transform(this.drdate, "yyyy-MM-dd").toString()) >= Date.parse(this.datePipe.transform(this.authservice.getServerDate, "yyyy-MM-dd").toString())) {
    
          }else{
            return this.dashboardService.openSnackBar("Select Present or future date", "OK");
          }
        }
        if(type ==0){
          this.showspinner = true;
        }
    
        this.opdvisitService.patientDrdetaill[0].pK_ExamId =this.examid;
      this.opdvisitService.patientDrdetaill[0].fK_VisitId=this.emrservice.visitid;
      this.opdvisitService.patientDrdetaill[0].fK_DoctorId =this.opdvisitService.DoctorIdEmr;
      this.opdvisitService.patientDrdetaill[0].isEdit =this.examid > 0?true:false;
      this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
      this.opdvisitService.patientDrdetaill[0].nextReviewDate= this.opdvisitService.patientDrdetaill[0].nextReview ==0?'1900-01-01':this.opdvisitService.patientDrdetaill[0].nextReviewDate;
      let payload = {
        
        DrExam: {
          ...this.opdvisitService.patientDrdetaill[0]
           
          },

          DrFinding: []
          ,
          DrDiag: [],
          DrPrescrip: [
          ],
          DrInvest: []
          , DrSurgery: []
        }
        try {
            this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroyreview$)).subscribe(data => {
            if (data['statusCode'] == 1) {
              this.emrservice.enabledisablebtnRev =true;
              if(this.examid >0){
                this.emrservice.savedrWorkupTrackingSatus('Modify Doctor Workup','true','DR');
               }else{
                this.emrservice.savedrWorkupTrackingSatus('Doctor Workup','false','DR');
               }
              this.showspinner = false;
              this.examid = data['id'];
              this.emrservice.examid = data['id'];
             // this.emrservice.content.next('2');
             // this.getReviewData(this.opdvisitService.patientdetails.pkRegId);
             this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId,this.opdvisitService.visitid,this.opdvisitService.DoctorIdEmr,1);
              this.emrservice.drWorkupExamStatus(this.emrservice.visitid,this.emrservice.examid !=null?this.emrservice.examid:0);
              this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
            } else {
              this.showspinner = false;
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          },
            err => {
              this.showspinner = false;
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              } 
              else if(err.error.statusCode == 422){
                this.dashboardService.openSnackBar(err.error.message,"OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
              // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");

            }
          );
        }
        catch (error) {
          this.showspinner = false;
        }

      } else {
        this.dashboardService.openSnackBar("Please Select Patient", "OK");
      }
    // }else{
    //   this.dashboardService.openSnackBar("Review days must be more than zero days", "OK");
    // }
    } else {
      this.dashboardService.openSnackBar("Please Select Visit List", "OK");
    }
  }else{
    this.dashboardService.openSnackBar("Add Permission Denied", "OK");
  }
}else{
  this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
}
  }
 
  
  // helplist pop up 
  refReasonPOpup() {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: 'NextReviewNotes'
      }

    });

      dialogRef.afterClosed().pipe(takeUntil(this.destroyreview$)).subscribe(result => {
      if (result != 0) {
        this.onReviewGrid(result, 5);

      }
    });
  }

  ngOnDestroy():void {
       this.voice.stop();         
    this.voice.destroy();
    this.destroyreview$.next(true);
    this.destroyreview$.unsubscribe();
    this.service.Reviewtext = null;
    this.examdetailArray = null;
    this.searchValue02=null;
    this.examid=null;
    this.appointmentid = null;
    this.nextreview = null;
    this.slot = null;
    this.drdate=null;
    this.nextreviewNote = null;
    this.appoitmenttypearray = null;
    this.rdate=null;
  }

    
monthDiff(d1, d2) {
var months;
months = (d2.getFullYear() - d1.getFullYear()) * 12;
months -= d1.getMonth();
months += d2.getMonth();
return months <= 0 ? 0 : months;
}
calculateDiff(dateSent){
  let currentDate = new Date();
  dateSent = new Date(dateSent);
  
  return Math.floor(( Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate()) - Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) /(1000 * 60 * 60 * 24));
  }

  startService(){
    this.service.Reviewtext = '';
    this.service.start('Next Review Note');
  }
  
  stopService(){
    this.opdvisitService.patientDrdetaill[0].nextReviewNote = this.service.Reviewtext;
    this.emrservice.enabledisablebtnRev = false;
    this.service.stop('Next Review Note'); 
  }

  closedialog(){
    this.dialogRef.close();
  }
  }